import { isSameDay } from 'date-fns';
import React from 'react';
import { LendiMemberType } from '../../../../../twilio';
import Avatar from '../Avatar';
import { Footer } from '../Footer';
import { MessageBodyWrapper } from '../style';
import { Content, ContentWrapper, MessageWrapper, TimeWrapper } from './style';
import { Body } from '@lendi-ui/typography';
import { getPrivacyPolicyLink } from '../../../../../utils';
import { giveMeHyperlink } from '../../../../../utils/giveMeHyperlink/index';
import { PRIVACY_POLICY_TEXT } from '../../../../../utils/constants';
import { Brand, getBrandFromHostname } from '@lendi/lala-utils';
var BRAND_LENDI = 'Lendi';
var BRAND_DOMAIN = 'Domain Home Loans';
var BRAND_AUSSIE = 'Aussie';
export var ReceivedMessage = function (_a) {
    var _b;
    var message = _a.message, nextMessage = _a.nextMessage, members = _a.members, identity = _a.identity, teamMember = _a.teamMember, shouldShowTimestamp = _a.shouldShowTimestamp, shouldShowAvatars = _a.shouldShowAvatars, shouldShowSeenBy = _a.shouldShowSeenBy, isExperiment = _a.isExperiment;
    var brand = getBrandFromHostname();
    var me = members.find(function (member) { return member.identity === identity; });
    var coApplicants = members.filter(function (member) { return member.type === LendiMemberType.CUSTOMER && member.identity !== identity; });
    var coApplicantsNames = '';
    if (coApplicants.length === 0) {
        // Do nothing
    }
    else if (coApplicants.length === 1) {
        coApplicantsNames = "".concat(coApplicants[0].firstName, " ").concat(coApplicants[0].lastName);
    }
    else {
        var fullNames = coApplicants.map(function (member) { return "".concat(member.firstName, " ").concat(member.lastName); });
        coApplicantsNames = fullNames.slice(0, coApplicants.length - 1).join(', ');
        coApplicantsNames += " and ".concat(fullNames[fullNames.length - 1]);
    }
    var messageWithNames = message.text, author = message.author;
    if (author && author.type === LendiMemberType.BOT) {
        switch (brand) {
            case Brand.Aussie:
                messageWithNames = messageWithNames.split('{{home_loan_provider_name}}').join(BRAND_AUSSIE);
                break;
            case Brand.Domain:
                messageWithNames = messageWithNames.split(BRAND_LENDI).join(BRAND_DOMAIN); // this is for previously created channel persisted with welcome message containing `Lendi`
                messageWithNames = messageWithNames.split('{{home_loan_provider_name}}').join(BRAND_DOMAIN);
                break;
            case Brand.Lendi:
            default:
                messageWithNames = messageWithNames.split('{{home_loan_provider_name}}').join(BRAND_LENDI);
                break;
        }
        messageWithNames = messageWithNames.replace('{{current_user_first_name}}', (me === null || me === void 0 ? void 0 : me.type) === LendiMemberType.CUSTOMER
            ? me.firstName === 'Customer'
                ? ''
                : me.firstName
            : ((_b = coApplicants[0]) === null || _b === void 0 ? void 0 : _b.firstName) || '');
        var hlsName = 'Home Loan Specialist';
        if ((teamMember === null || teamMember === void 0 ? void 0 : teamMember.firstName) && (teamMember === null || teamMember === void 0 ? void 0 : teamMember.lastName)) {
            // If both FN & LN are available, show both
            hlsName = "".concat(teamMember === null || teamMember === void 0 ? void 0 : teamMember.firstName, " ").concat(teamMember === null || teamMember === void 0 ? void 0 : teamMember.lastName);
        }
        else if (teamMember === null || teamMember === void 0 ? void 0 : teamMember.firstName) {
            // If firstName is available, show firstName
            hlsName = teamMember === null || teamMember === void 0 ? void 0 : teamMember.firstName;
        }
        messageWithNames = messageWithNames.replace('{{hls_name}}', hlsName);
        if (coApplicants.length > 0) {
            messageWithNames = messageWithNames.split('{{applicant}}').join(coApplicantsNames);
        }
    }
    var shouldShowAuthor = !nextMessage || message.author !== nextMessage.author || !isSameDay(nextMessage.dateCreated, message.dateCreated);
    return (React.createElement(MessageWrapper, null,
        React.createElement(ContentWrapper, null,
            shouldShowAuthor && React.createElement(Avatar, { member: author, isFooter: false }),
            React.createElement(Content, { hasAvatar: shouldShowAuthor },
                React.createElement(MessageBodyWrapper, { isExperiment: isExperiment }, author &&
                    author.type !== LendiMemberType.CUSTOMER &&
                    messageWithNames.indexOf(PRIVACY_POLICY_TEXT) > -1 ? (React.createElement("span", { dangerouslySetInnerHTML: {
                        __html: messageWithNames.replace(PRIVACY_POLICY_TEXT, giveMeHyperlink({
                            text: PRIVACY_POLICY_TEXT,
                            url: getPrivacyPolicyLink(brand),
                            // url: getPri :,
                        })),
                    } })) : (React.createElement(React.Fragment, null, messageWithNames))))),
        React.createElement(TimeWrapper, null,
            (shouldShowTimestamp || shouldShowAvatars) && (React.createElement(Footer, { message: message, nextMessage: nextMessage, members: members, shouldShowAvatars: shouldShowAvatars })),
            shouldShowSeenBy && (React.createElement(Body, { size: "xxs", color: "shade.700", mt: "xxxs" },
                React.createElement("strong", null, "Seen by"),
                " ",
                message.seenByNames)))));
};
//# sourceMappingURL=index.js.map